import { Box } from '@chakra-ui/react';
import { useAuth } from '@invara-dev/react-base';
import { useEffect } from 'react';
import { ApplicationRoutes } from 'src/constants/applicationRoutes';

export const Home = () => {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.hasLoaded) {
      return;
    }
    if (auth.isAuthenticated) {
      window.location.href = ApplicationRoutes.booking.hotelSearchLanding;
    } else {
      window.location.href = ApplicationRoutes.account.login;
    }
  }, [auth.isAuthenticated, auth.hasLoaded]);
  return <Box>Please Wait...</Box>;
};
